import script from "./BetslipKeypad.vue?vue&type=script&setup=true&lang=js"
export * from "./BetslipKeypad.vue?vue&type=script&setup=true&lang=js"

import "./BetslipKeypad.vue?vue&type=style&index=0&id=2c860f90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c860f90"]])

export default __exports__